import { render, staticRenderFns } from "./walletAdjustAffiliate.vue?vue&type=template&id=ba0a947c&scoped=true&lang=pug"
import script from "./walletAdjustAffiliate.vue?vue&type=script&lang=js"
export * from "./walletAdjustAffiliate.vue?vue&type=script&lang=js"
import style0 from "./walletAdjustAffiliate.vue?vue&type=style&index=0&id=ba0a947c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0a947c",
  null
  
)

export default component.exports